import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Router } from '@angular/router';
import { Constant } from 'src/app/shared/service/utils/contant';
import { SuivieRecommandation } from 'src/app/shared/models/remmandation';

@Component({
  selector: 'app-recommandation-execution',
  standalone: false,
  templateUrl: './recommandation-execution.component.html',
  styleUrl: './recommandation-execution.component.scss'
})


export class RecommandationExecutionComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;
  filteredData: any[] = []; // Données filtrées
  searchTerm: string = ''; // Terme de recherche
  recommadationItems: any = [];
  modalRef: NgbModalRef | null = null;
  paginatedItems: any[] = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  item: SuivieRecommandation = new SuivieRecommandation()
  itemToDelete!: any;
  @ViewChild('recoommandationModal') modalContent: TemplateRef<any>;
  @ViewChild('traitementModal') modalContent1: TemplateRef<any>;


  paginatedItems1: any[] = [];
  first1: number = 0;
  rows1: number = 10;
  totalRecords1: number = 0;

  missionItems: any[] = [];
  typemissionItems: any[] = [];
  serviceItems: any[] = [];

  constructor(
    private modalService: NgbModal,

    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {

    // this.projetService.projetCreated$.subscribe(() => {
    //   this.fetchDataAction();
    // });
  }

  ngOnInit(): void {
    //   //console.log(" this.localstorage.getUsers().data.reference", this.localstorage.getInfoUserToService());

    this.item.user_reference = this.localstorage.getInfoUserToService()?.data?.reference
    this.getRecommandation();
    const currentYear = new Date().getFullYear();

  }

  getRecommandation() {
    this.isLoading = true;

    this.paramservice.getRecommandation().subscribe(
      (response: any) => {
        this.getTypeMission();

        this.isLoading = false;
        this.recommadationItems = response.data;
        this.filteredData = [...this.recommadationItems]; // Initialiser filteredData avec toutes les données
        this.totalRecords = this.filteredData.length;
        this.updatePagination();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }


  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePagination();
  }


  updatePagination() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.filteredData.slice(start, end);

    ////console.log("this.updateRessourceStats",this.paginatedItems);
  }


  onPageChange1(event: any) {
    this.first1 = event.first;
    this.rows1 = event.rows;
    this.updatePagination();
  }


  updatePagination1() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems1 = this.traitemeentItems.slice(start, end);

    ////console.log("this.updateRessourceStats",this.paginatedItems);
  }
  applyFilter(term: string) {
    this.searchTerm = term.trim().toLowerCase();

    if (this.searchTerm) {
      this.filteredData = this.recommadationItems.filter(item =>
        item.libelle.toLowerCase().includes(this.searchTerm)
      );
    } else {
      // Réinitialiser les données filtrées si la recherche est vide
      this.filteredData = [...this.recommadationItems];
    }

    this.totalRecords = this.filteredData.length;
    this.first = 0; // Revenir à la première page après le filtrage
    this.updatePagination();
  }




  addProjetToActiviter(item: any) {

    ////console.log("item");

    this.localstorage.saveProjetActivite(item);

    this.router.navigate(['/suivi/planification/projet-activite'])
  }



  openModal(item: any) {
    console.log("item", item);
    this.item.date_suivi = new Date().toISOString().split('T')[0];

    this.item.libelle = item.libelle;
    this.item.recommandation_id = item.reference,
      // this.item.
      this.modalService.open(this.modalContent, {
        size: 'xl',
        backdrop: 'static',
        keyboard: false
      });
  }


  traitemeentItems: any = [];
  openModalTraitement(item: any) {
    //console.log("item", item);
    this.router.navigate(['/suivi/execution/traitement-recommandation', item.reference]);
  }

  close() {
    this.modalService.dismissAll()
  }

  saveSuivi() {

    if (!this.item.date_mo) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "La date de mise en oeuvre est obligatoire" });
      return;
    }

    if (!this.item.niveau_execution) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Le niveau d'execution est obligatoire" });
      return;
    }

    this.ngxService.start();
    this.paramservice.addSuiviRecommndation(this.item).subscribe(
      (response: any) => {
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.ngxService.stop();
        this.getRecommandation();
        this.modalService.dismissAll();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error: any) => {
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: error?.error?.message });
        this.ngxService.stop();

        ////console.log("une erreur est survenu", error);
      }
    );
  }
  getTypeMission() {
    this.paramservice.getTypeMission().subscribe(
      (response: any) => {
        this.typemissionItems = response.data
        //console.log("this.typemissionItems", this.typemissionItems);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }
  getMission(item: any) {
    let requestData = {
      type_id: item
    }
    this.paramservice.getMission(requestData).subscribe(
      (response: any) => {
        this.missionItems = response.data
        this.getService();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );

  }

  getService() {

    this.paramservice.fetchDataService().subscribe(
      (response: any) => {
        this.serviceItems = response.data
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }


  //confirme la suppression
  confirmDeletion(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer cette recommandation ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deleteReccomandation(item.reference).subscribe(

          (response: any) => {
            this.ngxService.stop();
            ////console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.getRecommandation();
          },
          (error) => {
            ////console.log("une erreur est survenu",error);
            this.ngxService.stop();
            this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: error });

          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'error', summary: 'X-Project', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }//end confirmDelet
}